var render, staticRenderFns
import script from "./detailActivity.vue?vue&type=script&lang=js"
export * from "./detailActivity.vue?vue&type=script&lang=js"
import style0 from "./detailActivity.vue?vue&type=style&index=0&id=6be3197d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be3197d",
  null
  
)

export default component.exports